<template lang="pug">
  figure
    picture
      template(
        v-if="block.innerBlocks.length > 1")
        template(
          v-for="(innerBlock, key) in block.innerBlocks")
          Block(
            v-if="key === 0"
            :key="`responsiveImageSet-${key}`"
            :block="innerBlock"
            :block-id="`source_${sourceMedia(key)}`"
            :lazy="blockId !== 'block-no-0'")
      Block(
        :key="`responsiveImageSet-${block.innerBlocks.length - 1}`"
        :block="block.innerBlocks[block.innerBlocks.length - 1]"
        :block-id="`img_${blockId}_${imageMedia(block.innerBlocks.length)}`"
        :lazy="blockId !== 'block-no-0'")
    figcaption(v-if="imageCaption") {{imageCaption}}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { CORE_IMAGE } from "~/constants/blocks"

export default defineComponent({
  name: "ResponsiveImageSet",
  props: {
    block: {
      required: true,
      type: Object as () => Block
    },
    blockId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      screenLg: 992
    }
  },
  computed: {
    imageCaption() {
      const lastBlock = this.block.innerBlocks[this.block.innerBlocks.length - 1]

      if (lastBlock.type !== CORE_IMAGE) {
        return null
      }

      const regex = /<figcaption[^>]*>([^"]+)<\/figcaption>/
      const caption = regex.exec(lastBlock.innerHtml)

      if (caption) {
        return caption[1]
      }

      return null
    }
  },
  methods: {
    sourceMedia(key: number) {
      if (key === 0) {
        return `(min-width: ${this.screenLg}px)`
      }

      return ""
    },
    imageMedia(imageCount: number) {
      if (imageCount === 2 || imageCount === 3) {
        return `(max-width: ${this.screenLg - 1}px)`
      }

      return ""
    }
  }
})
</script>
